<template>
  <div class="recommend">
    <div class="banner">
      <div class="tui" @click="toRecommned"></div>
    </div>
    <div class="main">
      <div class="main-item main-item1"></div>
      <div class="main-item main-item2"></div>
      <div class="main-item main-item3"></div>
    </div>
    <div class="footer">
      <div class="btn" @click="shareClick">生成专属海报</div>
    </div>
  </div>
</template>

<script>
import { getopenid } from "../../request/api/user"
export default {
  data () {
    return {
    }
  },
  created () {
    // this.getWxCode()
    this.openid = this.$route.query.openid
    this.distributorId = this.$route.query.distributorId
    this.distributorType = 2
  },
  methods: {
    getUrlParam (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getWxCode () {
      let appid = "wx3dcc8b8f8d8bf78b" //为测试号id
      let code = this.getUrlParam("code") //是否存在code
      let local = window.location.href
      let openid = window.localStorage.getItem('openid') || this.$route.query.openid
      if (openid) {
        this.openid = openid
        return
      }
      if (!code && !openid) {
        window.location.href =
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
      } else if (!openid) {
        this.code = code
        getopenid({ code: this.code }).then(res => {
          this.openid = res.data.openid
          window.localStorage.setItem('openid', this.openid)
          history.back()
          window.location.reload()
        })
      }
    },
    toRecommned () {
      this.$router.push({
        name: 'myInfo',
        query: {
          openid: this.openid,
          distributorId: this.$route.query.distributorId,
          isBind: this.$route.query.isBind
        }
      })
    },
    shareClick () {
      let query = this.$route.query
      let isBind = query.isBind
      if (isBind == 0) {
        this.$router.replace({
          name: 'Home',
          query: {
            openid: this.openid
          }
        })
        return
      }
      this.$router.push({
        name: "share",
        query: {
          distributorId: this.distributorId,
          distributorType: 2
        }
      })
    },
  }
}
</script>

<style scoped lang='less'>
.recommend {
  position: relative;
  background: #7969fc;
  .banner {
    position: relative;
    height: 632px;
    background: url("./banner.png") no-repeat;
    background-size: cover;
    .tui {
      position: absolute;
      width: 180px;
      height: 68px;
      right: 0px;
      top: 32px;
      background: url("./tui.png") no-repeat;
      background-size: cover;
    }
  }
  .main {
    padding: 0 30px 160px;
    .head {
      padding: 43px 0;
      margin-top: 30px;
      background: #ffffff;
      border-radius: 16px;
      .text {
        font-size: 40px;
        font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
        font-weight: normal;
        color: #894a21;
        line-height: 47px;
      }
    }
    .main-item {
      margin-top: 30px;
      background: #ffffff;
      border-radius: 16px;
      &.main-item1 {
        height: 362px;
        background: url("./main1.png") no-repeat;
        background-size: cover;
      }
      &.main-item2 {
        height: 358px;
        background: url("./main2.png") no-repeat;
        background-size: cover;
      }
      &.main-item3 {
        height: 543px;
        background: url("./main3.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 690px;
      height: 90px;
      background: #0293de;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>